import React from 'react';
import PropTypes from 'prop-types';
import Chevron from '../../../../../public/static/icons/navigation-chevron-down.svg';
import FormattedText from '../../../../01_atoms/FormattedText';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../../utils/behaviorSettings';
import styles from './index.module.scss';

class BBCollapsedText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isHidden: true,
    };

    this.toggleDisplay = this.toggleDisplay.bind(this);
  }

  toggleDisplay(e) {
    e.preventDefault();
    this.setState((state) => ({
      isHidden: !state.isHidden,
    }));
  }

  render() {
    const { text, behaviorSettings = null, uuid = null } = this.props;
    const { isHidden } = this.state;

    const classes = [
      'bb',
      'bb-collapsed-text',
      styles['bb-collapsed-text'],
      generateClassNameByBehaviorSettings(behaviorSettings),
    ];

    return (
      <div className={classes.join(' ')} id={uuid}>
        <div className="container">
          <FormattedText className={`text ${isHidden ? 'hidden' : 'visible'}`} text={text} />
          <a
            className={`toggler ${isHidden ? 'closed' : 'opened'}`}
            onClick={this.toggleDisplay}
            href="#"
          >
            Read {isHidden ? 'more' : 'less'}
            <Chevron />
          </a>
        </div>
      </div>
    );
  }
}

BBCollapsedText.propTypes = {
  text: PropTypes.string.isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBCollapsedText;
